export const LOCAL_STORAGE_KEY = {
  refreshTokenKey: "_sq_rtoken",
  pwaStorageKey: "pwa_storage",
  pushToken: "push_token",
};
